// extracted by mini-css-extract-plugin
module.exports = {"green":"#5bc1a4","whyUsBriefColor":"#747474","offerCallNumber":"#006336","defaultButtonColor":"#006336","defaultProgressColor":"#9bc7af"};